import React from 'react'
import get from 'lodash/get'
import Category from '../components/category'

import Layout from '../components/layout'

import { Link } from 'gatsby'
import diversity from '../images/diversity.png'
import onFire from '../images/50onFire.png'

import technically from '../images/technical-ly-logo.png'
import pcmag from '../images/pcmag.png'
import ph from '../images/ph-logo.png'
import entrepreneur from '../images/entrepreneurship.png'
import WallOfLove from '../components/wall-of-love'

import unified from 'unified'
import markdown from 'remark-parse'
import html from 'remark-html'

class IndexPage extends React.Component {
  render() {
    const items = get(this, 'props.data.categories.edges')
    const patrons = get(this, 'props.data.patrons.edges')
    const supporters = get(this, 'props.data.supporters.edges')
    const top_supporters = get(this, 'props.data.top_supporters.edges')
    const bronze_sponsors = get(this, 'props.data.bronze_sponsors.edges')
    const silver_sponsors = get(this, 'props.data.silver_sponsors.edges')
    const gold_sponsors = get(this, 'props.data.gold_sponsors.edges')
    const platinum_sponsors = get(this, 'props.data.platinum_sponsors.edges')

    const hire = {
      category: 'Get Hired',
      slug: 'hire',
      color: 'rgb(248, 232, 199)',
      description:
        'A series featuring underrepresented people in tech looking for jobs',
    }
    const jobBoard = {
      category: 'Job Board',
      slug: 'job-board',
      color: '#d3e8e1',
      description: 'Find a job in tech',
    }
    const stories = {
      category: 'Stories',
      slug: 'stories',
      color: 'rgb(255, 209, 198)',
      description: 'Underrepresented people in tech share their stories',
    }

    return (
      <Layout>
        <div className="flex justify-center flex-wrap p-12 pb-6">
          <div className="w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
            <h1>
              A collection of resources for underrepresented people in tech
            </h1>
            <br />
            <p className="text-xl text-grey-darkest pr-4">
              Once a week, we’ll send you scholarships, events, job
              opportunities, and more.
            </p>
            <br />

            <Link
              to="/join"
              className="bg-black hover:bg-grey-dark text-white text-lg py-2 px-4 rounded no-underline inline-block"
              rel="noopener noreferrer"
              target="_blank"
            >
              Subscribe
            </Link>

            <div className="pt-6 pb-6 text-lg">
              <Link key="employers" to="/post-a-job" className="text-black">
                <small>Hiring? Click here →</small>
              </Link>
            </div>
          </div>
          <div className="w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
            <img
              src={diversity}
              className="w-full"
              alt="Illustration representing diverse people"
            />
          </div>
        </div>

        <div className="flex justify-center flex-wrap pt-0" id="resources">
          <Category key="job-board" data={jobBoard}>
            Job Board
          </Category>
          <Category key="hire" data={hire}>
            Talent Directory
          </Category>
          <Category key="stories" data={stories}>
            Stories
          </Category>
          {items.map(({ node }) => {
            return <Category key={node.data.slug} data={node.data} />
          })}
        </div>
        <div>
          <div className="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
            <h1 className="py-6 text-center text-grey-darkest text-3xl font-bold">
              As seen in
            </h1>
            <br />
            <div className="grid grid-cols-2 gap-8 md:grid-cols-6 lg:grid-cols-5">
              <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
                <a
                  href="https://technical.ly/philly/2019/03/21/list-75-career-building-resources-for-women-in-tech-meetups-books-mentorship/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img className="h-12" src={technically} alt="Technical.ly" />
                </a>
              </div>
              <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
                <a
                  href="https://www.pcmag.com/article/368920/40-online-resources-all-women-in-tech-careers-should-know-ab"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img className="h-12" src={pcmag} alt="PC Magazine" />
                </a>
              </div>
              <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
                <a
                  href="https://www.entrepreneur.com/article/335255"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img className="h-12" src={entrepreneur} alt="Entrepreneur" />
                </a>
              </div>
              <div className="col-span-1 flex justify-center md:col-span-3 lg:col-span-1">
                <a
                  href="https://www.producthunt.com/newsletter/2411"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img className="h-12" src={ph} alt="Product Hunt" />
                </a>
              </div>
              <div className="col-span-2 flex justify-center md:col-span-3 lg:col-span-1">
                <a
                  href="https://www.americaninno.com/dc/50-on-fire/meet-dc-innos-2019-50-on-fire/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img className="h-12" src={onFire} alt="DCINNO 50 on Fire" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <WallOfLove />

        <div className="p-6 text-center">
          <div className={platinum_sponsors.length > 0 ? 'block' : 'hidden'}>
            <h1 className="text-center">Our Platinum Sponsors</h1>

            <div className="py-6">
              <div className="mx-auto max-w-screen-md px-4 sm:px-6 lg:px-8">
                <div className="text-center">
                  {platinum_sponsors.map(({ node }) => {
                    return (
                      <div className="mt-10 lg:mt-0">
                        <div className=" items-center justify-center">
                          <a
                            href={node.data.URL}
                            className="no-underline text-center"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={node.data.Headshot[0].url}
                              alt={node.data.Name}
                              className="xs:h-32 rounded-lg p-6"
                            />
                          </a>
                        </div>
                        <div className="mt-5">
                          <div
                            className="mt-2 text-base leading-6 text-gray-700"
                            dangerouslySetInnerHTML={{
                              __html: unified()
                                .use(markdown)
                                .use(html)
                                .processSync(node.data.About),
                            }}
                          />
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>

          {/* Gold sponsors */}

          <div className={gold_sponsors.length > 0 ? 'block' : 'hidden'}>
            <h1 className="text-center">Our Gold Sponsors</h1>

            <div className="py-6">
              <div className="mx-auto max-w-screen-md px-4 sm:px-6 lg:px-8">
                <div className="md:grid md:grid-cols-1 lg:grid lg:grid-cols-1 lg:gap-8 text-center">
                  {gold_sponsors.map(({ node }) => {
                    return (
                      <div className="mt-10 lg:mt-0">
                        <div className=" items-center justify-center">
                          <a
                            href={node.data.URL}
                            className="no-underline text-center"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={node.data.Headshot[0].url}
                              alt={node.data.Name}
                              className="h-32 xs:h-24 rounded-lg p-6"
                            />
                          </a>
                        </div>
                        <div className="mt-5">
                          <div
                            className="mt-2 text-base leading-6 text-gray-700"
                            dangerouslySetInnerHTML={{
                              __html: unified()
                                .use(markdown)
                                .use(html)
                                .processSync(node.data.About),
                            }}
                          />
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>

          {/* Silver Sponsors */}
          <div className={silver_sponsors.length > 0 ? 'block' : 'hidden'}>
            <h1 className="text-center">Our Silver Sponsors</h1>

            <div className="py-6">
              <div className="mx-auto max-w-screen-md px-4 sm:px-6 lg:px-8">
                <div className="md:grid md:grid-cols-1 lg:grid lg:grid-cols-1 lg:gap-8 text-center">
                  {silver_sponsors.map(({ node }) => {
                    return (
                      <div className="mt-10 lg:mt-0">
                        <div className=" items-center justify-center">
                          <a
                            href={node.data.URL}
                            className="no-underline text-center"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={node.data.Headshot[0].url}
                              alt={node.data.Name}
                              className="h-32 xs:h-24 rounded-lg p-6"
                            />
                          </a>
                        </div>
                        <div className="mt-5">
                          <div
                            className="mt-2 text-base leading-6 text-gray-700"
                            dangerouslySetInnerHTML={{
                              __html: unified()
                                .use(markdown)
                                .use(html)
                                .processSync(node.data.About),
                            }}
                          />
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>

          {/* Bronze sponsors */}
          <div className={bronze_sponsors.length > 0 ? 'block' : 'hidden'}>
            <h1 className="text-center">Our Bronze Sponsors</h1>
            <br />
            <div className="py-6">
              <div className="mx-auto max-w-screen-md px-4 sm:px-6 lg:px-8">
                <div className="flex flex-wrap text-center">
                  {bronze_sponsors.map(({ node }) => {
                    return (
                      <div className="mt-10 lg:mt-0 md:w-1/2 lg:w-1/2 ml-auto mr-auto">
                        <div className=" items-center justify-center">
                          <a
                            href={node.data.URL}
                            className="no-underline text-center"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={node.data.Headshot[0].url}
                              alt={node.data.Name}
                              className="h-12 xs:h-8 rounded-md "
                            />
                          </a>
                        </div>
                        <div className="mt-5">
                          <p className="mt-2 text-base leading-6 text-gray-700 pl-4 pr-4 pb-4">
                            {node.data.About}
                          </p>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="pt-6 pb-6 text-lg text-center">
            <a
              href="https://form.jotform.com/212662749604157"
              className="text-black uppercase font-bold"
              rel="noopener noreferrer"
            >
              Sponsor Us →
            </a>
          </div>
        </div>
        <div className="p-6 text-center max-w-screen-md mx-auto">
          <div>
            <h1 className="pb-6">Thank you to our Supporters</h1>
            <div className="flex justify-center flex-wrap">
              {top_supporters.map(({ node }) => {
                return (
                  <a
                    href={node.data.URL}
                    className="no-underline text-sm leading-5 font-medium text-gray-700"
                  >
                    <div className="px-4 m-2">
                      <img
                        src={node.data.Headshot[0].url}
                        alt={node.data.Name}
                        className="w-16 h-16 rounded-full"
                      />
                    </div>
                    <br />
                    {node.data.Name}
                  </a>
                )
              })}
            </div>

            <div className="flex flex-wrap overflow-hidden p-6 justify-center">
              {supporters.map(({ node }) => {
                return (
                  <a href={node.data.URL} className="no-underline m-1">
                    <img
                      src={node.data.Headshot[0].url}
                      alt={node.data.Name}
                      className="inline-block w-12 rounded-full text-white shadow-solid"
                    />
                  </a>
                )
              })}
              {patrons.map(({ node }) => {
                return (
                  <a href={node.data.URL} className="no-underline m-1">
                    <img
                      className="inline-block h-12 w-12 rounded-full text-white shadow-solid"
                      src={node.data.Headshot[0].url}
                      alt=""
                    />
                  </a>
                )
              })}
            </div>
          </div>

          <div className="pt-6 pb-6 text-lg">
            <a
              target="_blank"
              href="https://www.patreon.com/diversifytech"
              className="text-black uppercase font-bold"
              rel="noopener noreferrer"
            >
              Become a Patron →
            </a>
          </div>
        </div>
      </Layout>
    )
  }
}

export default IndexPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }

    categories: allAirtable(
      filter: {
        table: { eq: "Categories" }
        data: { published: { eq: "Yes" } }
      }
    ) {
      edges {
        node {
          id
          data {
            category
            slug
            color
            published
            description
          }
        }
      }
    }

    bronze_sponsors: allAirtable(
      filter: {
        table: { eq: "Patreons" }
        queryName: { eq: "Bronze Sponsors" }
      }
      sort: { fields: [data___Date_Added], order: DESC }
    ) {
      edges {
        node {
          id
          data {
            Name
            Headshot {
              url
            }
            URL
            About
            Date_Added
          }
        }
      }
    }

    silver_sponsors: allAirtable(
      filter: {
        table: { eq: "Patreons" }
        queryName: { eq: "Silver Sponsors" }
      }
    ) {
      edges {
        node {
          id
          data {
            Name
            Headshot {
              url
            }
            URL
            About
          }
        }
      }
    }

    gold_sponsors: allAirtable(
      filter: { table: { eq: "Patreons" }, queryName: { eq: "Gold Sponsors" } }
    ) {
      edges {
        node {
          id
          data {
            Name
            Headshot {
              url
            }
            URL
            About
          }
        }
      }
    }

    platinum_sponsors: allAirtable(
      filter: {
        table: { eq: "Patreons" }
        queryName: { eq: "Platinum Sponsors" }
      }
    ) {
      edges {
        node {
          id
          data {
            Name
            Headshot {
              url
            }
            URL
            About
          }
        }
      }
    }

    top_supporters: allAirtable(
      filter: { table: { eq: "Patreons" }, queryName: { eq: "Top Supporters" } }
      sort: { fields: [data___Patronage_Since_Date], order: DESC }
    ) {
      edges {
        node {
          id
          data {
            Name
            Headshot {
              url
            }
            URL
          }
        }
      }
    }

    supporters: allAirtable(
      filter: { table: { eq: "Patreons" }, queryName: { eq: "Supporters" } }
    ) {
      edges {
        node {
          id
          data {
            Name
            Headshot {
              url
            }
            URL
          }
        }
      }
    }

    patrons: allAirtable(
      filter: { table: { eq: "Patreons" }, queryName: { eq: "Patrons" } }
    ) {
      edges {
        node {
          id
          data {
            Name
            Headshot {
              url
            }
            URL
          }
        }
      }
    }
  }
`
